// Redesign 2026 – přepínač formulářů ([data-rd-form-switch], includes/template-parts/redesign/recepce/formulare.php).
// Formuláře jsou ve stránce všechny, JS jen ukazuje vybraný: tlačítko prvního kroku ukáže svá
// podtlačítka (je-li jich víc) a předvybere první z nich. Výběr se zapisuje do ?formular= v adrese
// (replaceState), ať jde odkaz poslat dál a obnovení stránky zůstane na stejném formuláři.
// Vedle formuláře se ukáže karta popisu služby ([data-rd-fs-info]) – podtlačítka, jinak tlačítka.
export default function initRedesignFormSwitch() {
  document.querySelectorAll('[data-rd-form-switch]').forEach((root) => {
    const groups = root.querySelectorAll('[data-rd-fs-group]');
    const subs = root.querySelectorAll('[data-rd-fs-subs]');
    const items = root.querySelectorAll('[data-rd-fs-item]');
    const panels = root.querySelectorAll('[data-rd-fs-panel]');
    const infos = root.querySelector('[data-rd-fs-infos]');
    const cards = root.querySelectorAll('[data-rd-fs-info]');

    const press = (buttons, isOn) => {
      buttons.forEach((btn) => btn.setAttribute('aria-pressed', isOn(btn) ? 'true' : 'false'));
    };

    const remember = (slug) => {
      const url = new URL(window.location.href);
      url.searchParams.set('formular', slug);
      window.history.replaceState(window.history.state, '', url);
    };

    // karta podtlačítka, jinak karta tlačítka; bez karty se sloupec schová
    const showInfo = (slug, group) => {
      if (!infos) {
        return;
      }
      const keys = [...cards].map((card) => card.dataset.rdFsInfo);
      const key = keys.includes(slug) ? slug : (keys.includes(group) ? group : '');
      cards.forEach((card) => {
        card.hidden = card.dataset.rdFsInfo !== key;
      });
      infos.hidden = key === '';
    };

    const showItem = (slug) => {
      press(items, (btn) => btn.dataset.rdFsItem === slug);
      let group = '';
      panels.forEach((panel) => {
        panel.hidden = panel.dataset.rdFsPanel !== slug;
        if (!panel.hidden) {
          group = panel.dataset.rdFsPanelGroup;
        }
      });
      showInfo(slug, group);
      remember(slug);
    };

    const showGroup = (slug) => {
      press(groups, (btn) => btn.dataset.rdFsGroup === slug);
      subs.forEach((box) => {
        box.hidden = box.dataset.rdFsSubs !== slug;
      });
      // první formulář tlačítka (u jednoho formuláře rovnou on)
      const first = root.querySelector(`[data-rd-fs-panel-group="${CSS.escape(slug)}"]`);
      if (first) {
        showItem(first.dataset.rdFsPanel);
      }
    };

    groups.forEach((btn) => btn.addEventListener('click', () => showGroup(btn.dataset.rdFsGroup)));
    items.forEach((btn) => btn.addEventListener('click', () => showItem(btn.dataset.rdFsItem)));
  });
}
